module.exports = __webpack_public_path__ + "img/member_cards_icon_435001.825c7a16.png";